import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";
const faqs = [{
  question: "Wie bekomme ich das PDF nach dem Kauf?",
  answer: "Sofort nach der Zahlung erhalten Sie den Download-Link per E-Mail (auch im Spam-Ordner nachsehen). Der Download funktioniert auf allen Geräten - PC, Tablet, Smartphone. Sie können es unbegrenzt oft herunterladen."
}, {
  question: "Funktioniert das PDF auf dem Handy/Tablet?",
  answer: "Ja, absolut! Das PDF ist optimiert für alle Geräte - iPhone, iPad, Android-Smartphones und -Tablets. Sie können es mit jedem PDF-Reader öffnen (z.B. Adobe Reader, Apple Books, Google PDF Viewer)."
}, {
  question: "Welche Zahlungsmethoden werden akzeptiert?",
  answer: "Sie können per Kreditkarte (Visa, Mastercard, American Express), PayPal, Apple Pay, Google Pay oder Klarna bezahlen. Die Zahlung wird über Payhip abgewickelt - sicher und SSL-verschlüsselt."
}, {
  question: "Was wenn es mir nicht gefällt?",
  answer: "Sie haben 14 Tage Geld-zurück-Garantie ohne Wenn und Aber. Einfach eine E-Mail an osmanbaltaci@hotmail.com und Sie erhalten Ihr Geld zurück. Kein Risiko für Sie."
}, {
  question: "Bekomme ich eine Rechnung?",
  answer: "Ja! Nach dem Kauf erhalten Sie automatisch eine Rechnung per E-Mail von Payhip. Diese ist für private und geschäftliche Zwecke (z.B. Heilpraktiker, Apotheken) verwendbar."
}, {
  question: "Ist das wissenschaftlich fundiert?",
  answer: "Ja. Das Quellenverzeichnis umfasst 200+ Studien auf Seite 560-600 mit PubMed-Links, ISBN-Nummern und peer-reviewed Journals. Jedes Naturmittel basiert auf wissenschaftlicher Evidenz oder jahrhundertelanger traditioneller Anwendung."
}, {
  question: "Ersetzt das den Arzt?",
  answer: "Nein. Bei ernsthaften oder unklaren Symptomen steht im Buch explizit: 'Zum Arzt!'. Dieses Buch ist Bildung und Information, keine medizinische Beratung. Es ergänzt die Schulmedizin, ersetzt sie nicht."
}, {
  question: "Ist das Esoterik?",
  answer: "Nein. Nur Naturmittel mit wissenschaftlicher Evidenz (Studien) ODER jahrhundertelanger traditioneller Anwendung werden aufgenommen. Keine unbelegten Heilversprechen, keine Pseudowissenschaft."
}, {
  question: "Kann ich das auch ohne Vorkenntnisse verstehen?",
  answer: "Ja. Alle Fachbegriffe werden erklärt. Das Buch ist für Laien geschrieben – verständlich, aber wissenschaftlich korrekt. Das Inhaltsverzeichnis ermöglicht schnelles Finden des richtigen Mittels."
}, {
  question: "Gibt es Updates bei neuen Studien?",
  answer: "Ja. Wenn relevante neue Forschungsergebnisse vorliegen, erhalten alle Käufer kostenlos die aktualisierte Version per E-Mail. Das Wissen bleibt auf dem neuesten Stand."
}, {
  question: "Wie aktuell ist das Wissen?",
  answer: "Die verwendeten Studien stammen aus den Jahren 2010-2024, mit Schwerpunkt auf aktueller Forschung. Traditionelles Heilwissen wird mit modernen wissenschaftlichen Erkenntnissen kombiniert."
}, {
  question: "Sind die Naturmittel in Deutschland verfügbar?",
  answer: "Ja. Alle beschriebenen Mittel sind in Deutschland legal erhältlich – in Apotheken, Reformhäusern oder online. Kosten: unter 50€ pro Mittel. Praktikabilität war ein wichtiges Auswahlkriterium."
}, {
  question: "Warum so viele Seiten? Ist das nicht zu viel?",
  answer: "Sie müssen nicht alles lesen. Nutzen Sie das Inhaltsverzeichnis wie eine Suchmaschine: Problem → Seitenzahl → Lösung. 2 Minuten. Die Tiefe ermöglicht fundiertes Verständnis statt oberflächlicher Tipps."
}, {
  question: "Gibt es Nebenwirkungen und Kontraindikationen?",
  answer: "Ja, diese werden bei jedem Mittel aufgeführt. Es gibt klare Hinweise zu Wechselwirkungen mit Medikamenten, Schwangerschaft, Kindern und Vorerkrankungen. Sicherheit hat höchste Priorität."
}, {
  question: "Was, wenn ein Mittel bei mir nicht funktioniert?",
  answer: "Das ist normal. Nicht jedes Mittel funktioniert bei jedem Menschen gleich. Deshalb finden Sie für die meisten Beschwerden mehrere alternative Ansätze. Sie haben 150+ Naturmittel zur Auswahl."
}];
const FAQSection = () => {
  return <section className="py-24 bg-gradient-to-br from-background via-accent/5 to-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16 space-y-4">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full mb-4 shadow-sm">
              <HelpCircle className="w-5 h-5 text-primary" />
              <span className="text-sm font-semibold text-primary">Häufig gestellte Fragen</span>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-foreground">
              Noch Fragen?
            </h2>
            <p className="text-xl text-muted-foreground">
              Hier finden Sie Antworten auf die wichtigsten Fragen zu diesem E-Book
            </p>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} className="border border-border/50 rounded-xl px-6 bg-card shadow-soft hover:shadow-hover transition-all duration-300 hover:border-primary/30">
                <AccordionTrigger className="text-left hover:no-underline py-6">
                  <span className="font-semibold text-foreground pr-4">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>

          <div className="mt-12 p-6 md:p-8 rounded-xl bg-primary/5 border-2 border-primary/20 text-center">
            <p className="text-foreground text-base md:text-lg leading-relaxed">
              <strong className="block mb-2 text-lg md:text-xl">Noch weitere Fragen?</strong>
              Schreiben Sie uns jederzeit an:{" "}
              <a href="mailto:osmanbaltaci@hotmail.com" className="text-primary hover:underline font-semibold">osmanbaltaci@hotmail.com</a>
              <br />
              <span className="text-sm text-muted-foreground">
                Wir antworten in der Regel innerhalb von 24 Stunden.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default FAQSection;